import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';

/** Repeating coastal scenery, independent of any map or camera entry point.
 * Colors belong to the caller's planes; the small accent fills are static.
 * All three tiles share a2400px period at their intended1:1 display scale. */
export const COASTAL_TOWN_SILHOUETTES: Readonly<Record<'headlands' | 'water' | 'quays', ParallaxSvgSpec>> = {
  headlands: {
    tile: {
      viewBoxWidth: 2400, viewBoxHeight: 360,
      // Low sea cliffs, an offshore islet and the long stone breakwater.
      // No lighthouse: the open coast belongs to the town's existing story.
      path: 'M0 360V210 C110 214 176 192 254 178 L318 158L366 154L411 128 '
        + 'L466 122L509 101L570 103L621 74L672 66L726 88L777 92L816 123 '
        + 'L881 133L922 158L1001 169 C1090 185 1160 201 1230 205 '
        + 'L1292 176L1334 173L1366 153L1411 148L1450 172L1490 178L1528 202 '
        + 'C1610 211 1670 192 1730 183 L1798 169L1846 170L1896 138 '
        + 'L1955 138L1990 152L2054 151L2108 178 C2200 196 2315 207 2400 210V360Z',
      glowPath: 'M407 132L468 126L507 111L512 113L470 130L409 136Z '
        + 'M622 78L671 71L724 93L775 97L776 100L722 97L670 75L623 82Z '
        + 'M1848 171L1898 143H1953L1989 156L1990 159L1952 147H1900L1850 175Z',
      glowColor: 0x7b7b97, glowAlpha: 0.13,
    },
  },
  water: {
    tile: {
      viewBoxWidth: 2400, viewBoxHeight: 200,
      path: 'M0 200V50 C200 48 400 52 600 50 C800 48 1000 52 1200 50 '
        + 'C1400 48 1600 52 1800 50 C2000 48 2200 52 2400 50V200Z',
      // Twelve broken reflections, never an animated shimmer or a bright platform edge.
      glowPath: 'M72 62H164V64H72Z M334 73H406V75H334Z '
        + 'M528 111H650V113H528Z M752 66H816V68H752Z '
        + 'M892 153H996V155H892Z M1110 80H1230V82H1110Z '
        + 'M1368 65H1452V67H1368Z M1512 121H1584V123H1512Z '
        + 'M1662 66H1800V68H1662Z M1868 168H1976V170H1868Z '
        + 'M2092 60H2172V62H2092Z M2250 102H2350V104H2250Z',
      glowColor: 0x8e94b2, glowAlpha: 0.13,
    },
  },
  quays: {
    tile: {
      viewBoxWidth: 2400, viewBoxHeight: 240,
      // Inhabited outer quay: small warehouses separated by open water, a low
      // loading arm, paired bare masts and timber piles. These are background forms.
      path: 'M0 240V228 C80 226 142 230 204 228 L204 214H212V228 '
        + 'H294V132L320 132L382 85L447 132H470V218H502V232 '
        + 'H668V208H675V231H736V119H744V175H792V179H744V229 '
        + 'H930V225H978V146L1034 106L1090 146V221H1130V230 '
        + 'H1240V198H1248V229H1316V223H1370V102H1376V165H1424V168H1376V223 '
        + 'H1490V132H1496V183H1540V186H1496V230 '
        + 'H1690V121L1714 121L1780 71L1850 121H1874V218H1908V227 '
        + 'H2096V215H2104V228 C2180 225 2300 230 2400 228V240Z',
      // Six small upper windows. Light stays high, away from street-level heads/captions.
      glowPath: 'M340 120H348V128H340Z M392 105H400V117H392Z '
        + 'M1010 127H1018V137H1010Z M1044 120H1052V132H1044Z '
        + 'M1738 108H1746V118H1738Z M1798 100H1806V110H1798Z',
      glowColor: 0xc69b65, glowAlpha: 0.24,
    },
  },
};
